import React, { useState, useEffect, useRef } from "react";
import "../Survey/SurveyPage.css";
import activeMic from "../icons/mic-on.svg";
import inactiveMic from "../icons/mic-off.svg";
import QuestionCarousel from "../../components/Carousel/QuestionCarousel";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { contentPlanActions, postActions, questionsActions } from "../../store";
import {message, notification, Space, Button, Spin, Popover, Alert} from "antd";
import {ReloadOutlined} from "@ant-design/icons";
import { PostPage } from "./PostsPage";
import { CreatePost } from "./CreatePost";
import { useTranslation } from "react-i18next";
import {fetchWrapper} from "../../helpers";
import {SlowGenerationCard} from "../../components/Cards/SlowGenerationCard";
import {ImeanHeader} from "../../components/Header/Header";
import LoadingOverlay from "../../components/Overlays/LoadingOverlay";

const baseUrl = `${process.env.REACT_APP_API_URL}`;

const GeneratingBar = ({ show, text, onReload, showReload }) => {
  if (!show) return null;
  return (
      <div style={{
        position: "sticky",
        top: 0,
        zIndex: 30,
        background: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(6px)",
        borderBottom: "1px solid #f0f0f0",
      }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: 8, display: "flex", alignItems: "center", gap: 8 }}>
          <Spin size="small" />
          <span style={{ fontWeight: 500 }}>{text}</span>
          <div style={{ marginLeft: "auto" }}>
            {showReload ? (
                <Button size="small" icon={<ReloadOutlined />} onClick={onReload}>
                  {/* i18n key reused */}
                  {text.includes("…") ? text : "Reload"}
                </Button>
            ) : null}
          </div>
        </div>
      </div>
  );
};

export const Post = () => {
  const user = useSelector((obj) => obj.auth.user);
  const params = useParams();
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const contentPlan = useSelector((obj) => obj.contentPlan.contentPlan);
  const post = useSelector((obj) => obj.post.post);
  const contentPlanLoading = useSelector((obj) => obj.contentPlan.loading);
  const postLoading = useSelector((obj) => obj.post.loading);
  const generating = useSelector((obj) => obj.post.generating);
  const interval = useRef(null);
  const [notificationApi, notificationContextHolder] =
      notification.useNotification();
  const [showReload, setShowReload] = useState(false);
  const [revealReload, setRevealReload] = useState(false);
  const pollRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    // Очистить предыдущие данные, чтобы не мигал старый пост
    dispatch(postActions.resetPost());
    dispatch(contentPlanActions.resetContentPlan());
    if (params.contentId) {
      dispatch(contentPlanActions.getContentPlanById(params.contentId));
      dispatch(postActions.getPost(params.contentId));
    }
  }, [dispatch, params.contentId]);

  useEffect(() => {
    if (generating) {
      interval.current = setInterval(() => {
        dispatch(contentPlanActions.getContentPlanById(params.contentId));
        dispatch(postActions.getPost(params.contentId));
      }, 5000);
    } else {
      clearInterval(interval.current);
      interval.current = null;
    }

    return () => {
      clearInterval(interval.current);
    };
  }, [dispatch, generating, interval]);

  // Reload button if the generation takes more than 40 seconds
  useEffect(() => {
    let timer;
    if (generating) {
      timer = setTimeout(() => setShowReload(true), 20000);
    } else {
      setShowReload(false);
    }
    return () => clearTimeout(timer);
  }, [dispatch, generating, interval]);

  // Smooth animation for reload button mount
  useEffect(() => {
    if (showReload) {
      const id = setTimeout(() => setRevealReload(true), 30);
      return () => clearTimeout(id);
    }
  }, [showReload])

  //   useEffect(() => {
  //     if (socket) {
  //       socket.on("finishedPost", () => {
  //         dispatch(contentPlanActions.getContentPlanById(params.contentId));
  //         dispatch(postActions.getPost(params.contentId));
  //       });
  //     }
  //   }, [dispatch, params.contentId, socket]);

  useEffect(() => {
    if (!generating) {
      if (pollRef.current) {
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
      return;
    }
    if (pollRef.current) return; // already polling

    pollRef.current = setInterval(() => {
      // fetch latest in the background
      dispatch(contentPlanActions.getContentPlanById(params.contentId));
      dispatch(postActions.getPost(params.contentId));
    }, 5000);

    // pause on unmount
    return () => {
      clearInterval(pollRef.current);
      pollRef.current = null;
    };
  }, [generating, dispatch, params.contentId]);

  useEffect(() => {
    if (!generating) return;
    const id = setTimeout(() => setShowReload(true), 20000);
    return () => clearTimeout(id);
  }, [generating]);

  const isLoadingFinished = !contentPlanLoading && !postLoading;

  const openNotification = () => {
    const key = `open${Date.now()}`;
    const btn = (
      <Space>
        <Button
          type="primary"
          size="small"
          onClick={() => navigate("/support")}
        >
          {t("posts.goToSupport")}
        </Button>
      </Space>
    );
    notificationApi.open({
      message: t("functions.error"),
      description: t("posts.unknownError"),
      btn,
      key,
    });
  };

  return (
    <>
      {notificationContextHolder}
      <div>
        <ImeanHeader initialDark={true}></ImeanHeader>

        {/* NEW: sticky lightweight generating bar */}
        <GeneratingBar
            show={generating}
            text={`${t("post.generating")}…`}
            showReload={showReload}
            onReload={() => window.location.reload()}
        />
        {/*{generating ? (*/}
        {/*  <div style={{ textAlign: "center" }}>*/}
        {/*    {t("post.generating")}...*/}
        {/*    <div className='w-full h-[40vh] flex justify-center items-end'>*/}
        {/*      <Spin size="large" />*/}
        {/*    </div>*/}
        {/*    {showReload && (*/}
        {/*        <div>*/}
        {/*          <SlowGenerationCard*/}
        {/*              show={showReload}*/}
        {/*              message={t("functions.reloadPageMessage") || "Generation takes more than anticipated. You can refresh the page."}*/}
        {/*              onRefresh={() => window.location.reload()}*/}
        {/*              buttonLabel={t("functions.reloadPage") || t("functions.reloadPage") || "Reload"}*/}
        {/*          />*/}
        {/*        </div>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*) : isLoadingFinished ? (*/}
        {/*  post ? (*/}
        {/*    <PostPage />*/}
        {/*  ) : (*/}
        {/*    <CreatePost openNotification={openNotification} />*/}
        {/*  )*/}
        {/*) : (*/}
        {/*  <div style={{ textAlign: "center" }}>{t("functions.loading")}</div>*/}
        {/*)}*/}

            <LoadingOverlay message={"..."} loading={generating}>
              {/* Always keep the main view, no full-page spinner swap */}
              {isLoadingFinished ? (
                  post ? (
                      <PostPage />
                  ) : (
                      <CreatePost openNotification={openNotification} />
                  )
              ) : (
                  <div style={{ textAlign: "center" }}>{t("functions.loading")}</div>
              )}
            </LoadingOverlay>
      </div>
    </>
  );
};
